import search from "../assets/search.svg";
import { useSelector, useDispatch } from "react-redux";
import {
  Grid,
  InputBase,
  Chip,
  Typography,
  List,
  ListItem,
} from "@material-ui/core";
import { useState, useEffect, useRef } from "react";
import axios from "axios";
import { url, auth_key, user_id } from "../constants";
import { setStates } from "../redux/states";
import { useHistory, useParams } from "react-router-dom";
import { Close } from "@material-ui/icons";
import { withNamespaces } from "react-i18next";
import { setFilters } from "../redux/filters";

const getSearchSuggestions = async (search, source) => {
  try {
    const response = await axios.get(`${url}search/${search}`, {
      cancelToken: source.token,
      headers: {
        "X-Api-Key": auth_key,
      },
      params: {
        User_ID: user_id,
      },
    });
    return response?.data;
  } catch (error) {
    console.log(error);
  }
};

function Searchbar(props, { t }) {
  const isDesktopOrLaptop = useSelector((state) => state.screenSize.value);
  const camera = useSelector((state) => state.camera.value);
  const states = useSelector((state) => state.states.value);
  let { query } = useParams();
  const [keyword, setKeyword] = useState(states?.name ? states.name : query);
  const [searched, setSearched] = useState(false);
  const [data, setData] = useState([]);
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    window.addEventListener("click", () => {
      setSearched(false);
    });
  });

  useEffect(() => {
    if (camera?.suggestions?.length > 0) {
      setSearched(true);
      setData(camera.suggestions);
    }
  }, [camera.suggestions]);

  const isMounted = useRef(null);
  useEffect(() => {
    const cancelToken = axios.CancelToken;
    const source = cancelToken.source();

    (async () => {
      if (keyword?.length >= 3 && isMounted?.current) {
        setSearched(true);
        const suggestions = await getSearchSuggestions(keyword, source);
        setData(suggestions === {} ? [] : suggestions);
      } else {
        setSearched(false);
        setData([]);
        isMounted.current = true;
      }
    })();
    return () => {
      source.cancel();
    };
  }, [keyword]);
  const _ListItem = (name, chip, ISIN) => {
    return (
      <div key={name}>
        <ListItem
          style={{
            paddingTop: "0px",
            paddingBottom: "15px",
          }}
          button
          onClick={(e) => {
            setSearched(false);
            setKeyword(name);
            e.target.blur();
            dispatch(
              setStates({
                ...states,
                companies: [],
                filters: {},
                Sectors: [],
                name: name,
                ISIN: ISIN,
                tabValue: chip === "ETFs" ? 2 : 1,
              })
            );
            //   if (props?.setClicked) {
            //     props.setClicked({
            //       STOCK: chip === "ETFs" ? false : true,
            //       ETF: chip === "ETFs" ? true : false,
            //       FUNDS: false,
            //       BONDS: false,
            //     });
            //   }
            dispatch(setFilters({}));
            history.push("/etfSearch/name");
            history.push(
              chip !== "theme"
                ? `/search-results/${ISIN ? ISIN : name}/${
                    chip === "ETFs" ? 2 : 1
                  }`
                : `/search-results/${ISIN ? ISIN : name}/${
                    chip === "ETFs" ? 2 : 1
                  }`
            );
          }}
        >
          <Grid container style={{ display: "flex", alignItems: "center" }}>
            <Grid item xs={3}>
              <Chip
                variant="outlined"
                color="#3F98F5"
                label={chip}
                style={{
                  borderRadius: "10px",
                  color: "#0040ff",
                  backgroundColor: "#adc7fe",
                  marginRight: "10px",
                  fontSize: "10px",
                  fontWeight: 600,
                  height: "20px",
                  width: "70px",
                  fontFamily: "Overpass",
                  display: "flex",
                  alignItems: "center",
                }}
              />
            </Grid>
            <Grid item xs={9}>
              <Typography
                style={{
                  fontWeight: 300,
                  fontSize: "16px",
                  paddingLeft: isDesktopOrLaptop ? "0" : "17px",
                  color: "#6C6A6A",
                  height: "21px",
                  textDecoration: "",
                  fontFamily: "Overpass",
                }}
              >
                {isDesktopOrLaptop
                  ? name
                  : name.length > 12
                  ? `${name.substr(0, 12)}...`
                  : name}
              </Typography>
            </Grid>
          </Grid>
        </ListItem>
      </div>
    );
  };

  return (
    <div
      style={{
        maxHeight: props.height
          ? props.height
          : isDesktopOrLaptop
          ? "60px"
          : "40px",
        zIndex: 3,
        width: "100%",
        marginBottom: isDesktopOrLaptop ? "30px" : "20px",
      }}
    >
      <List
        style={{
          maxHeight: "100%",
          overflowY: "scroll",
          backgroundColor: "white",
          paddingBottom: searched ? "8px" : 0,
          zIndex: 5,
          width: isDesktopOrLaptop ? "100%" : "100%",
          borderRadius: searched ? "15px" : "40px",
          height: !searched
            ? props.height
              ? props.height
              : isDesktopOrLaptop
              ? "60px"
              : "40px"
            : "auto",
        }}
        className="invisible-scrollbar Searchbar"
        disablePadding
        subheader={
          <div
            style={{
              height: props.height
                ? props.height
                : isDesktopOrLaptop
                ? "60px"
                : "40px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Grid item xs={10}>
              <InputBase
                autoFocus={props.unfocused ? false : true}
                inputProps={{
                  style: {
                    padding: 0,
                  },
                }}
                value={keyword}
                placeholder={props.placeHolder}
                style={{
                  fontWeight: 800,
                  fontSize: "16px",
                  color: "#16063b",
                  width: "100%",
                  height: "120%",
                  display: "flex",
                  alignItems: "center",
                  fontFamily: "Overpass",
                  textAlign: "center",
                  paddingLeft: isDesktopOrLaptop ? "18px" : "16px",
                }}
                onChange={(e) => {
                  setKeyword(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.target.blur();
                    dispatch(
                      setStates({
                        ...states,
                        companies: [],
                        filters: {},
                        Sectors: [],
                        name: keyword,
                        ISIN: null,
                        tabValue: 1,
                        countries: [],
                        continents: [],
                        numberOfStock: null,
                        numberOfBond: null,
                        numberOfETF: null,
                      })
                    );
                    setSearched(false);
                    history.push(`/etfSearch/${keyword}`);
                  }
                }}
              />
            </Grid>
            <Grid
              item
              xs={2}
              style={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <div
                className="SearchOval"
                style={{
                  height: props.height
                    ? "31px"
                    : isDesktopOrLaptop
                    ? "46px"
                    : "34px",
                  width: props.height
                    ? "31px"
                    : isDesktopOrLaptop
                    ? "46px"
                    : "34px",
                  marginRight: isDesktopOrLaptop
                    ? props.height
                      ? "6px"
                      : "8px"
                    : "3px",
                  cursor: keyword?.length > 0 ? "pointer" : "unset",
                }}
                onClick={() => {
                  setKeyword("");
                }}
              >
                {keyword?.length === 0 ? (
                  <img
                    src={search}
                    alt="icon"
                    style={{ width: isDesktopOrLaptop ? "" : "15px" }}
                  ></img>
                ) : (
                  <Close
                    style={{
                      color: "#f8f8f8",
                      fontSize: isDesktopOrLaptop ? "21px" : "15px",
                    }}
                  />
                )}
              </div>
            </Grid>
          </div>
        }
      >
        {searched ? (
          <div
            style={{
              opacity: 0.3,
              backgroundColor: "#d8d8d8",
              height: "1px",
              marginBottom: "18px",
              marginTop: "3px",
              marginLeft: "15px",
              marginRight: "15px",
            }}
          />
        ) : null}
        {searched
          ? data?.map((item) => {
              return _ListItem(item?.Name, item?.type, item?.ISIN);
            })
          : null}
      </List>
    </div>
  );
}

export default withNamespaces()(Searchbar);
